import { Radio, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { advisorFormApi } from '../../../api/advisor-form/advisor-form.api';
import InputTextField from '../../../components/input/inputTextField';
import { MyCourseOfStudyApi } from '../../../api/my-course-of-study/my-course-of-study.api';
import { NavigateFunction, useLocation, useNavigate, useParams } from 'react-router-dom';
import { ButtonOutlined, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import { advisorEstimateApi } from '../../../api/advisor-estimate/advisor-estimate.api';
import { swalError, swalSuccess } from '../../../components/alert/swal';
import { useTranslation } from 'react-i18next';

export default function EvaluateTeachers() {
    const { t } = useTranslation();
    const [advisor_form_name, set_advisor_form_name] = useState<string>('')
    const [from, setForm] = useState<any[]>([])
    const { id } = useParams();
    const location = useLocation()
    const [remark, setremark] = useState<string>('')
    const [id_advisor_form, setid_advisor_form] = useState<any>()
    const navigate: NavigateFunction = useNavigate();

    const search_params = new URLSearchParams(location.search);
    const id_course_annual = search_params.get("id_course_annual");
    const id_course_annual_employee = search_params.get("id_course_annual_employee");
    const id_advisor_estimate = search_params.get("id_advisor_estimate");
    const [detail, setDetail] = useState<any>();
    // i18n-ignore: advisor type names are translated at render site
    const [advisorType, setAdvisorType] = useState<any[]>([{ id_advisor_type: 'LEAD_INSTRUCTOR', advisor_type_name: 'ครูฝึกสอนนำ' }, { id_advisor_type: 'CO_INSTRUCTOR', advisor_type_name: 'ผู้สอนร่วม' }, { id_advisor_type: 'CO_ADVISOR', advisor_type_name: 'ที่ปรึกษาร่วม' }])

    const [formDetail, setFormDetail] = useState<any[]>([
        {
            "id_advisor_estimate_detail": 0,
            "id_advisor_estimate": 0,
            "id_advisor_form_detail": 0,
            "id_advisor_form_detail_sub": 0,
            "estimate_point": "string",
            "status": "string"
        }
    ])
    // const getEstimateById = async () => {
    //     const res = await advisorEstimateApi.getEstimateById(Number(id_advisor_estimate));
    //     const data = res.data;
    //     if (data.status < 300) {
    //         console.log(JSON.stringify(res.data.data.advisor_estimate_detail));
           
    //     } else {

    //     }
    // }

    const getFormDetail = async (id_advisor_form: any) => {
        const res = await advisorFormApi.getAdvisorFormById(id_advisor_form);
        const data = res.data;
        if (data.status < 300) {
            setForm(data.data?.advisor_form_detail);
            set_advisor_form_name(data.data?.advisor_form_name)
        } else {
            setForm([])
        }
    }
    const getDetail = async () => {
        const res = await MyCourseOfStudyApi.getCourseAnnual(id, id_course_annual);
        const data = res.data;
        if (data.status < 300) {
            console.log(data.data);
            setDetail(data.data)
            getFormDetail(data.data?.id_advisor_form)
            setid_advisor_form(data.data?.id_advisor_form)
        } else {
            // setForm(null)
        }
    }

    useEffect(() => {
        getDetail()
        // getFormDetail()
        // if (id_advisor_estimate) {
        //     getEstimateById()
        // }

    }, [])

    const handleSubmit = async () => {
        const allSubDetails = from.flatMap(item => item.advisor_form_detail_sub);
        const body = {
            id_advisor_estimate: undefined,
            id_advisor_student: undefined,
            id_course_annual_employee: id_course_annual_employee,
            id_advisor_form: id_advisor_form,
            remark: remark,
            status: "active",
            advisor_estimate_detail: allSubDetails?.map((item: any) => {
                return {
                    id_advisor_form_detail: item?.id_advisor_form_detail,
                    id_advisor_form_detail_sub: item?.id_advisor_form_detail_sub,
                    estimate_point: item?.estimate_point,
                    status: "active"
                }
            })
        }
        await advisorEstimateApi.post(body).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('ประเมินผู้สอน เรียบร้อย'), undefined, undefined, () => navigate(-1))

                // handleClose()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
        })
    }
    const handleRadioChange = (i: any, ix: any, value: any) => {
        setForm((prev) =>
            prev.map((item, index) =>
                index === i
                    ? {
                        ...item,
                        advisor_form_detail_sub: item.advisor_form_detail_sub.map(
                            (subItem: any, subIndex: any) =>
                                subIndex === ix
                                    ? { ...subItem, estimate_point: value }
                                    : subItem
                        ),
                    }
                    : item
            )
        );
    };
    // console.log(JSON.stringify(from));

    return (
        <div>

            <Typography variant='h3'>
                {t("ประเมินผู้สอน")}
            </Typography>
            <div className='my-4'>
                <div style={{
                    boxShadow: '0px 0px 8.8px 0px #00000026',
                    padding: '40px',
                    borderRadius: '16px',
                    display: 'flex',
                    gap: '20px'
                }}>
                    <div style={{
                        boxShadow: '0px 0px 6px 0px #00000033',
                        padding: '10px',

                        borderRadius: '16px',

                    }}>
                        <img src={process.env.REACT_APP_FILE_BASE_API + '/' + detail?.instructors?.find((item: any) => item?.id_course_annual_employee == id_course_annual_employee)?.file_path} style={{
                            width: '148px',
                            height: '148px', objectFit: 'cover', objectPosition: 'center'
                        }} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <div>
                            <Typography variant='h5'>{detail?.instructors?.find((item: any) => item?.id_course_annual_employee == id_course_annual_employee)?.employee_name}</Typography>
                            <Typography>{detail?.instructors?.find((item: any) => item?.id_course_annual_employee == id_course_annual_employee)?.email_organization || '-'}</Typography>
                            <Typography>{t(advisorType?.find((x: any) => x.id_advisor_type === detail?.instructors?.find((item: any) => item?.id_course_annual_employee == id_course_annual_employee)?.position_annual)?.advisor_type_name || "")}</Typography>
                        </div>
                    </div>

                </div>

            </div>
            <Typography variant='h5'>{advisor_form_name}</Typography>
            {from?.map((item: any, i: number) => {
                return (
                    <div style={{ marginTop: '20px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography sx={{ flexBasis: '60%', fontSize: "16px", fontWeight: 'bold' }}>{item?.advisor_form_detail_name}</Typography>
                            <div style={{ display: 'flex', gap: '5px', flexBasis: '40%', width: '100%', justifyContent: "space-between" }}>
                                <Typography>{t("น้อยที่สุด (1)")}</Typography>
                                <Typography>{t("น้อย (2)")}</Typography>
                                <Typography>{t("ปานกลาง (3)")}</Typography>
                                <Typography>{t("มาก (4)")}</Typography>
                                <Typography>{t("มากที่สุด (5)")}</Typography>

                            </div>
                        </div>
                        {item?.advisor_form_detail_sub?.map((x: any, ix: any) => (
                            <div key={ix} style={{ display: "flex", justifyContent: "space-between", marginLeft: "20px" }}>
                                <Typography sx={{ flexBasis: "60%" }}>{x?.advisor_form_detail_sub_name}</Typography>
                                <div style={{ display: "flex", gap: "5px", flexBasis: "40%", justifyContent: "space-between" }}>
                                    {[1, 2, 3, 4, 5].map((val) => (
                                        <div key={val} style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                            <Radio
                                                checked={x?.estimate_point === val}
                                                onChange={() => handleRadioChange(i, ix, val)}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}

                    </div>
                )
            })}
            <InputTextField
                value={remark || ''}
                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setremark(e.target.value)
                }
                }
                placeholder={t('ความคิดเห็น')}
                heading={t('ความคิดเห็น')}
                multiline
                minRow={6}
                inputHeight={'auto'}
            />
            <section className="col-span-12 flex items-center justify-center gap-4 my-4">
                <ButtonOutlined
                    onClick={() => {
                        // navigate(routeName.cms.MeetingCalendar);
                        // navigate(routeName.cms.MeetingCaledarDetail.replace(':id', `${id}`));
                    }}
                    buttonName={t("ย้อนกลับ")}
                    btnProps={{
                        width: "150px",
                    }}
                />


                <ButtonPrimary
                    onClick={() => {
                        // handleSubmit(inputValueFormStudent.information);
                        // handleSubmit()
                        handleSubmit()
                    }}
                    mode="success"
                    buttonName={t("ยืนยัน")}
                    btnProps={{
                        width: "150px",
                    }}
                />
            </section>
        </div>
    )
}
